module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mikmak-site"
    }
  }, [_c('Header'), _vm._v(" "), _c('HeroContent'), _vm._v(" "), _c('PartnersHero'), _vm._v(" "), _c('MikMakAttach'), _vm._v(" "), _c('WhyMikMak'), _vm._v(" "), _c('Services'), _vm._v(" "), _c('Solutions'), _vm._v(" "), _c('Press'), _vm._v(" "), _c('Footer'), _vm._v(" "), _c('CookieBanner')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-749dd8ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 488
// module chunks = 0